// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contentful-page{margin-top:115px}.contentful-page .contentful-component{padding-top:75px;padding-bottom:75px}.contentful-page .contentful-component.scrolling-logos{padding-top:0;padding-bottom:0}.contentful-page .contentful-component.scrolling-logos .py-l5-48{padding-top:0;padding-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
